import { StyleSheet, View } from 'react-native';
import { Bot, UserRound } from 'lucide-react-native';
import { tokens } from '../../theme/tokens';
import type { AssistantChatMessageViewModel } from '../../types/aiAssistant';
import { AppText } from '../ui/AppText';

type AssistantConversationThreadProps = {
  messages: AssistantChatMessageViewModel[];
};

const modeLabelMap: Record<AssistantChatMessageViewModel['mode'], string> = {
  explain: '讲题',
  correct: '批改',
  paper: '试卷',
};

export function AssistantConversationThread({ messages }: AssistantConversationThreadProps) {
  if (!messages.length) {
    return null;
  }

  return (
    <View style={styles.thread}>
      {messages.map((message) => {
        const student = message.role === 'student';
        return (
          <View
            key={message.id}
            style={[styles.row, student ? styles.studentRow : styles.assistantRow]}
          >
            {!student ? (
              <View style={styles.avatar}>
                <Bot size={16} color={tokens.colors.white} />
              </View>
            ) : null}
            <View style={[styles.bubble, student ? styles.studentBubble : styles.assistantBubble]}>
              <AppText
                variant="caption"
                weight="bold"
                tone={student ? 'default' : 'primary'}
                style={student ? styles.studentModeLabel : null}
              >
                {modeLabelMap[message.mode]}
              </AppText>
              <AppText variant="body" style={student ? styles.studentText : null}>
                {message.content}
              </AppText>
            </View>
            {student ? (
              <View style={styles.studentAvatar}>
                <UserRound size={16} color={tokens.colors.white} />
              </View>
            ) : null}
          </View>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  thread: {
    gap: tokens.spacing.md,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    gap: tokens.spacing.sm,
  },
  assistantRow: {
    justifyContent: 'flex-start',
  },
  studentRow: {
    justifyContent: 'flex-end',
  },
  avatar: {
    width: 30,
    height: 30,
    borderRadius: tokens.radius.full,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: tokens.colors.primary,
  },
  studentAvatar: {
    width: 30,
    height: 30,
    borderRadius: tokens.radius.full,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: tokens.colors.success,
  },
  bubble: {
    maxWidth: '78%',
    borderRadius: tokens.radius.lg,
    paddingHorizontal: tokens.spacing.md,
    paddingVertical: tokens.spacing.sm,
    gap: 2,
  },
  assistantBubble: {
    backgroundColor: tokens.colors.surface,
    borderWidth: tokens.border.width,
    borderColor: tokens.colors.border,
  },
  studentBubble: {
    backgroundColor: tokens.colors.primary,
  },
  studentModeLabel: {
    color: tokens.colors.white,
    opacity: 0.82,
  },
  studentText: {
    color: tokens.colors.white,
  },
});
